module.exports = __webpack_public_path__ + "img/account-image.68a6593f.png";